import React from 'react'

const NoPhotoIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={52} height={52} viewBox="0 0 19.7 16.9" {...props}>
      <defs>
        <clipPath id="a">
          <path fill="none" d="M0 4.43h14.52V16.9H0z" />
        </clipPath>
        <clipPath id="b">
          <path fill="none" d="M9.56 0H19.7v10.14H9.56z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          fill="#333945"
          d="m10.8 5.9-.87-.92c-.34-.36-.8-.56-1.29-.56H5.88c-.49 0-.96.2-1.29.56l-.86.92c-.34.36-.8.56-1.29.56h-.66C.79 6.46 0 7.25 0 8.24v6.88c0 .98.8 1.78 1.78 1.78h10.97c.98 0 1.78-.8 1.78-1.78V8.24c0-.98-.79-1.78-1.77-1.78h-.66c-.49 0-.95-.2-1.29-.56"
        />
        <path
          fill="none"
          stroke="#fff"
          strokeMiterlimit={10}
          d="M10.62 11.34a3.35 3.35 0 1 1-3.35-3.35c1.85 0 3.35 1.5 3.35 3.35Z"
        />
      </g>
      <g clipPath="url(#b)">
        <path
          fill="#ed1b35"
          d="M19.7 5.07a5.07 5.07 0 1 1-10.14 0 5.07 5.07 0 0 1 10.14 0"
        />
      </g>
    </svg>
  )
}

export default NoPhotoIcon
